import * as React from "react";
import type { SVGProps } from "react";
const SvgVulnerabilityManagement = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={66}
    height={66}
    fill="none"
    {...props}
  >
    <path
      stroke="#26A3DD"
      strokeWidth={1.75}
      d="m24.487 54.023-1.98 3.098c-.209.326-.224.74-.04 1.08l.727 1.341a1.064 1.064 0 0 1-.322 1.377l-1.021.72c-.419.294-.988.249-1.355-.108l-1.083-1.054a1.064 1.064 0 0 0-.94-.283l-3.12.59c-.39.074-.708.36-.822.74l-.469 1.564c-.154.516-.67.835-1.2.743l-1.21-.21a1.064 1.064 0 0 1-.882-1.056l.01-1.637a1.064 1.064 0 0 0-.476-.894l-2.717-1.797a1.064 1.064 0 0 0-1.094-.048l-1.332.722a1.064 1.064 0 0 1-1.377-.323l-.786-1.117a1.064 1.064 0 0 1 .16-1.406l1.136-1.018c.288-.258.413-.653.327-1.03l-.69-3.011a1.064 1.064 0 0 0-.686-.767l-1.535-.538a1.064 1.064 0 0 1-.696-1.186l.211-1.218c.092-.527.56-.904 1.094-.882l1.432.06c.373.016.727-.164.933-.476l1.783-2.696c.216-.328.235-.748.048-1.094l-.722-1.331a1.064 1.064 0 0 1 .323-1.377l1.117-.787a1.064 1.064 0 0 1 1.406.16l1.018 1.136c.258.288.653.413 1.03.327l3.011-.69c.356-.082.646-.34.767-.685l.547-1.562c.168-.48.65-.773 1.153-.702l1.908.27"
    />
    <circle
      cx={14.038}
      cy={50.546}
      r={4.36}
      fill="#D3ECF8"
      stroke="#26A3DD"
      strokeWidth={1.75}
      transform="rotate(-35.155 14.038 50.546)"
    />
    <circle
      cx={40.929}
      cy={33.489}
      r={14.032}
      fill="#D3ECF8"
      stroke="#26A3DD"
      strokeWidth={1.75}
    />
    <path
      stroke="#26A3DD"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.75}
      d="M40.621 1.688 64.418 12.78s3.17 21.658-5.284 36.448c0 0-4.726 10.069-18.46 15.083h-.263c-13.733-5.02-18.46-15.083-18.46-15.083-8.454-14.79-5.283-36.448-5.283-36.448L40.465 1.688h.156Z"
    />
    <path
      stroke="#26A3DD"
      strokeLinecap="round"
      strokeWidth={1.75}
      d="m46.893 28.52-7.95 8.945-3.975-3.727"
    />
  </svg>
);
export default SvgVulnerabilityManagement;
